import { auth, db } from "../firebase";
import { onSnapshot, collection, addDoc, serverTimestamp } from "firebase/firestore";
import useStore from "../store/useStore";

export default function getTransactions(callback) {
  const { vendorId } = useStore.getState();

  if (!vendorId) {
    console.log("No valid session context");
    return;
  }

  // Always fetch scan data from the vendor-wide subcollection
  // This allows the vendor to see all transactions across all branches
  const scansRef = collection(db, "vendorUsers", vendorId, "scans");
  const unsubscribe = onSnapshot(scansRef, (querySnap) => {
    const transactionsData = [];
    querySnap.forEach((doc) => {
      const data = doc.data();
      transactionsData.push({
        id: doc.id,
        ...data,
      });
    });

    if (callback && typeof callback === "function") {
      callback(transactionsData);
    }
  });
  
  return unsubscribe;
}

export const saveScan = async (scanData) => {
  const { vendorId, locationId, staffId } = useStore.getState();

  if (!vendorId || !locationId) {
    throw new Error("Cannot save scan: Missing location or vendor context (Not logged into a branchStore)");
  }

  // New flattened architecture: vendorUsers/{vId}/scans
  const scansRef = collection(db, "vendorUsers", vendorId, "scans");
  
  try {
    const docRef = await addDoc(scansRef, {
      ...scanData,
      staffId: staffId || null,
      locationId: locationId, // Kept for legacy compatibility if needed
      branchStoreId: locationId, // Explicitly named as requested
      scannedAt: serverTimestamp(),
      createdAt: serverTimestamp(), // Added for consistency with other parts of the app
    });
    return docRef.id;
  } catch (error) {
    console.error("Error saving scan:", error);
    throw error;
  }
};
